import { render, staticRenderFns } from "./MoleculeEditionProductPricesAndPlans.vue?vue&type=template&id=528abab6&"
import script from "./MoleculeEditionProductPricesAndPlans.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionProductPricesAndPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports